import { render } from "./OrderItemSkeleton.vue?vue&type=template&id=c8e5e8fe&scoped=true"
import script from "./OrderItemSkeleton.vue?vue&type=script&lang=js"
export * from "./OrderItemSkeleton.vue?vue&type=script&lang=js"

import "./OrderItemSkeleton.vue?vue&type=style&index=0&id=c8e5e8fe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e5e8fe"]])

export default __exports__